import React, { useEffect, useState } from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { BorderGradient } from 'processhub-components-lib';
import { FiPlus } from 'react-icons/fi';
import { ScriptsInterface } from './Script';

interface AddScriptModalProps {
    scripts: ScriptsInterface[];
    isOpen: boolean;
    mode: string;
    editScriptId: string;
    onSave: (data: ScriptsInterface) => void;
    onClose: () => void;
}

interface FormStateInterface {
    id: string;
    name: string;
    desc: string;
    runMode: string;
    frequency: string;
    time: string;
}

const AddScriptModal: React.FC<AddScriptModalProps> = ({ scripts, isOpen, mode, editScriptId, onSave, onClose }) => {
    const [formData, setFormData] = useState<FormStateInterface>({
        id: Math.random().toString(36).substring(2, 9),
        name: "",
        desc: "",
        runMode: "",
        frequency: "",
        time: "",
    });

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value, type } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };
    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const newScript = {
            id: formData.id,
            name: formData.name,
            desc: formData.desc,
            scheduleExec: formData.runMode
        };
        onSave(newScript);
        onClose();
    };

    useEffect(() => {
        if (mode === "edit") {
            const scriptToEdit = scripts.find((i) => i.id === editScriptId);
            if (!scriptToEdit) return;

            setFormData({
                id: scriptToEdit.id,
                name: scriptToEdit.name,
                desc: scriptToEdit.desc,
                runMode: scriptToEdit.scheduleExec,
                frequency: "",
                time: "",
            });
        }
    }, [isOpen]);

    return (
        <Dialog.Root open={isOpen} onOpenChange={onClose}>
            <Dialog.Portal>
                <Dialog.Overlay className="fixed inset-0 bg-black/60 z-50" />
                <Dialog.Content className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-50 w-[90vw] lg:w-[1024px] h-[70vh]">
                    <BorderGradient className='rounded-lg flex flex-col h-full w-full'>
                        <div className="bg-[#1A1A1A] rounded-lg p-6 relative text-white overflow-y-auto flex flex-col h-full">
                            <button
                                onClick={onClose}
                                className="absolute top-4 right-4 text-gray-400 hover:text-white"
                            >
                                <FiPlus size={24} className="rotate-45" />
                            </button>
                            <h2 className="text-xl font-semibold mb-6 text-white"> {mode === "edit" ? "Edit script" : "Add script"}</h2>
                            <form onSubmit={handleSubmit}>

                                <div className='mt-5'>
                                    <label className="block text-sm text-gray-400 mb-1">Script name</label>
                                    <input
                                        type="text"
                                        className="w-full bg-[#2A2A2A] border border-white/[0.08] rounded-md px-3 py-2 text-white"
                                        placeholder="Enter discount code"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className='mt-5'>
                                    <label className="block text-sm text-gray-400 mb-1">Description</label>
                                    <input
                                        type="text"
                                        className="w-full bg-[#2A2A2A] border border-white/[0.08] rounded-md px-3 py-2 text-white"
                                        placeholder="Enter discount code"
                                        name="desc"
                                        value={formData.desc}
                                        onChange={handleChange}
                                    />
                                </div>

                                <div className='bg-[#232323] rounded-lg p-2 my-5'>
                                    <h3>Schedule script execution</h3>
                                </div>

                                <div className="mt-5 flex gap-5 items-center">
                                    <div className="flex items-center gap-4">
                                        <input value={"manually"} onChange={handleChange} name='runMode' id='manually' type="radio" className='w-5 h-5 rounded-lg bg-black accent-black ' />
                                        <label htmlFor="manually">Run Manually</label>
                                    </div>
                                    <div className="flex items-center gap-4">
                                        <input value={"automatically"} onChange={handleChange} name='runMode' id='automatically' type="radio" className='w-5 h-5 rounded-lg bg-black accent-black' />
                                        <label htmlFor="automatically">Run Automatically</label>
                                    </div>
                                </div>

                                <div className='mt-5'>
                                    <label className="block text-sm text-gray-400 mb-1">If run automatically</label>
                                    <div className="grid grid-cols-2 gap-4 mt-5">

                                        <select
                                            className="w-full bg-[#2A2A2A] border border-white/[0.08] rounded-md px-3 py-2 text-white"
                                            name="frequency"
                                            value={formData.frequency}
                                            onChange={handleChange}
                                        >
                                            <option value="">Select frequency</option>
                                            <option value="Number">Ticketing system</option>
                                            <option value="GB">Payment gateway</option>
                                        </select>
                                        <select
                                            className="w-full bg-[#2A2A2A] border border-white/[0.08] rounded-md px-3 py-2 text-white"
                                            name="time"
                                            value={formData.time}
                                            onChange={handleChange}
                                        >
                                            <option value="">Time</option>
                                            <option value="Number">Number</option>
                                            <option value="GB">GB</option>
                                        </select>
                                    </div>
                                </div>


                                <div className="flex justify-end pt-4">
                                    <button
                                        type="button"
                                        onClick={onClose}
                                          className="flex items-center justify-center text-center gap-2 px-4 py-2 w-[140px] text-white rounded-lg hover:bg-[#3a3a3a33] transition-colors"
                                        >
                                        Cancel
                                    </button>

                                    <button
                                        className="flex items-cente justify-center gap-2 px-4 py-2 w-[140px] bg-[#2A2A2A] text-white rounded-lg hover:bg-[#3a3a3a33] transition-colors"
                                        type="submit"
                                        
                                    >
                                        Save
                                    </button>
                                </div>
                            </form>


                        </div>
                    </BorderGradient>
                </Dialog.Content>
            </Dialog.Portal>
        </Dialog.Root>
    );
};

export default AddScriptModal;
